'use client';
import { useState } from 'react';
import Image from 'next/image';
import { LanguageCode } from '@/lib/games';
import { translations } from '@/lib/translations';

interface TutorialVideosProps {
  lang: LanguageCode;
}

const TutorialVideos = ({ lang }: TutorialVideosProps) => {
  const [activeVideo, setActiveVideo] = useState<string | null>(null);

  const videos = [
    {
      id: '944XinS0sOk',
      title: 'Cat chaos prankster cut scenes gameplay android game mobile on play store ',
      description: 'Cat chaos prankster cut scenes gameplay android game mobile on play store',
    },
    {
      id: 'Go1Q91sCtc4',
      title: 'Cat chaos prankster gameplay',
      description: 'Cat chaos prankster gameplay',
    },
    {
      id: 'keQdEofZhrs',
      title: 'All special cat chaos prankster gameplay',
      description: 'All special cat chaos prankster gameplay',
    },
  ];

  return (
    <section className="content-card rounded-lg shadow-md p-6 mb-8">
      <h2 className="text-3xl font-bold mb-4 gradient-text">
        {translations.tutorials.title[lang]}
      </h2>
      <div className="grid grid-cols-3 gap-4">
        {videos.map((video) => (
          <div
            key={video.id}
            className="video-card p-4 rounded-lg cursor-pointer"
            onClick={() => setActiveVideo(video.id)}
          >
            <h3 className="text-xl font-semibold mb-2">{video.title}</h3>
            <p className="text-sm mb-3">{video.description}</p>
            <div className="aspect-video relative">
              <Image
                src={`https://img.youtube.com/vi/${video.id}/maxresdefault.jpg`}
                alt={video.title}
                fill
                className="rounded-lg object-cover"
              />
            </div>
          </div>
        ))}
      </div>

      {activeVideo && (
        <div
          className="fixed inset-0 bg-black/80 flex items-center justify-center z-50"
          onClick={() => setActiveVideo(null)}
        >
          <div className="relative w-full max-w-4xl mx-4">
            <button
              onClick={() => setActiveVideo(null)}
              className="absolute -top-10 right-0 text-white hover:text-gray-300 transition-colors"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <div className="aspect-video bg-black rounded-lg">
              <iframe
                width="100%"
                height="100%"
                src={`https://www.youtube.com/embed/${activeVideo}?autoplay=1`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                className="rounded-lg"
              />
            </div>
          </div>
        </div>
      )}
    </section>
  );
};

export default TutorialVideos;